if (customElements.get('form-modal') === undefined) {
  const classes = {
    siteOverflowed: 'util-SiteOverflowed',
  }
  class FormModal extends HTMLElement {
    constructor () {
      super()

      this.modalTriggerEls = document.querySelectorAll(
        '[data-el="form-modal.modal-trigger"]',
      )

      this.modalCloseEls = this.querySelectorAll(
        '[data-el="form-modal.modal-close"]',
      )

      this.newsletterEmailEl = document.querySelector(
        '[data-el="form-modal.newsletter-email"]',
      )

      this.newsletterFormEl = document.querySelector(
        '[data-el="form-modal.newsletter-form"]',
      )

      this.setupFormModal()
    }

    setupFormModal () {
      if (!this.modalTriggerEls) return

      this.modalTriggerEls.forEach(modalTriggerEl => {
        modalTriggerEl.addEventListener(
          'click',
          this.handleModalTrigger.bind(this),
        )
      })
      this.modalCloseEls.forEach(modalCloseEl => {
        modalCloseEl.addEventListener('click', this.handleModalClose.bind(this))
      })
    }

    handleModalTrigger = e => {
      if (this.dataset.formModalId === e.currentTarget.dataset.formModalId) {
        this.setAttribute('aria-hidden', 'false')
        document.body.classList.add(classes.siteOverflowed)

        const cognitoFormKey = this.dataset.cognitoFormKey
        const cognitoFormId = this.dataset.cognitoFormId
        const formId = `#${this.dataset.formModalId}`

        // eslint-disable-next-line no-undef
        const api = Cognito(cognitoFormKey)

        if (this.dataset.formModalId === 'newsletter') {
          const emailValue = this.newsletterEmailEl.value

          api.mount(cognitoFormId, formId).prefill({ EmailAddress: emailValue })
        } else {
          api.mount(cognitoFormId, formId)
        }
      }
    }

    handleModalClose = () => {
      this.setAttribute('aria-hidden', 'true')
      document.body.classList.remove(classes.siteOverflowed)
    }
  }

  customElements.define('form-modal', FormModal)
}

function loadStockistWidget() {
    if (!window.stockistWidgetLoaded) {
        var widgetContainer = document.getElementById('stockist-widget-container');
        var script = document.createElement('script');
        script.src = '//stockist.co/embed/v1/widget.min.js';
        script.async = true;
        widgetContainer.appendChild(script);
        window.stockistWidgetLoaded = true;
    }
}